import {
    take,
    put,
    call,
    all,
    takeLatest,
    takeEvery,
} from 'redux-saga/effects';
import { KudosActions as actions, notificationActions } from '../actions';
import { kudosService } from '../services';

/* Create Kudos Team Sagas */
function* handleAddKudosCategoryRequest() {
    const action = yield take(actions.addKudosCategoryRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(kudosService.addKudosCategory, dataParams);
        if (res.isError) {
            yield put(actions.addKudosCategoryError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.addKudosCategorySuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.addKudosCategoryError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get Kudos Category Sagas*/
function* handleGetKudosCategoryRequest() {
    const action = yield take(actions.getKudosCategoryRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(kudosService.getKudosCategory, dataParams);

        if (res.isError) {
            yield put(actions.getKudosCategoryError(res));

        } else {
            yield put(actions.getKudosCategorySuccess(res));
        }

    } catch (error) {
        yield put(actions.getKudosCategoryError());
    }
}

/* Create Kudos Sagas*/
function* handleCreateKudosRequest() {
    const action = yield take(actions.createKudosRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(kudosService.createKudos, dataParams);

        if (res.isError) {
            yield put(actions.createKudosError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

        } else {
            yield put(actions.createKudosSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }

    } catch (error) {
        yield put(actions.createKudosError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get Kudos Data Sagas */
function* handleGetKudosDataRequest() {
    const action = yield take(actions.getKudosDataRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(kudosService.getKudosData, dataParams);
        if (res.isError) {
            yield put(actions.getKudosDataError(res));

        } else {
            yield put(actions.getKudosDataSuccess(res));
        }
    } catch (error) {
        yield put(actions.getKudosDataError());


    }
}

/* Get Kudos Data Sagas */
function* handleAddKudosPointHistoryRequest() {
    const action = yield take(actions.addKudosPointHistoryRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(kudosService.addKudosPointHistory, dataParams);
        if (res.isError) {
            yield put(actions.addKudosPointHistoryError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.addKudosPointHistorySuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.addKudosPointHistoryError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));

    }
}

/* get User Kudos On Type Sagas*/
function* handleGetPointStatementRequest() {
    const action = yield take(actions.getPointStatementRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(kudosService.getPointStatement, dataParams);
        if (res.isError) {
            yield put(actions.getPointStatementError(res));
        } else {
            yield put(actions.getPointStatementSuccess(res));
        }
    } catch (error) {
        yield put(actions.getPointStatementError());
    }
}

/* Get Received Kudos On Filter Sagas*/
function* handleGetUserKudosOnTypeRequest() {
    const action = yield take(actions.getUserKudosOnTypeRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(kudosService.getUserKudosOnType, dataParams);
        if (res.isError) {
            yield put(actions.getUserKudosOnTypeError(res));
        } else {
            yield put(actions.getUserKudosOnTypeSuccess(res));
        }
    } catch (error) {
        yield put(actions.getUserKudosOnTypeError());
    }
}


/* Get Received Kudos On Filter Sagas*/
function* handleApproveRejectKudosRequest() {
    const action = yield take(actions.approveRejectKudosRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(kudosService.approveRejectKudos, dataParams);
        if (res.isError) {
            yield put(actions.approveRejectKudosError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.approveRejectKudosSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.approveRejectKudosError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));  
    }
}
/* -----------Watchers------------- */
function* handleAddKudosCategoryWatcher() {
    yield takeEvery(
        actions.addKudosCategoryRequest,
        handleAddKudosCategoryRequest,
    );
}

function* handleGetKudosCategoryWatcher() {
    yield takeEvery(
        actions.getKudosCategoryRequest,
        handleGetKudosCategoryRequest,
    );
}

function* handleCreateKudosWatcher() {
    yield takeEvery(
        actions.createKudosRequest,
        handleCreateKudosRequest,
    );
}

function* handleGetKudosDataWatcher() {
    yield takeEvery(
        actions.getKudosDataRequest,
        handleGetKudosDataRequest,
    );
}

function* handleAddKudosPointHistoryWatcher() {
    yield takeEvery(
        actions.addKudosPointHistoryRequest,
        handleAddKudosPointHistoryRequest,
    );
}

function* handleGetPointStatementWatcher() {
    yield takeEvery(
        actions.getPointStatementRequest,
        handleGetPointStatementRequest,
    );
}

function* handleGetUserKudosOnTypeWatcher() {
    yield takeEvery(
        actions.getUserKudosOnTypeRequest,
        handleGetUserKudosOnTypeRequest,
    );
}


function* handleApproveRejectKudosWatcher() {
    yield takeEvery(
        actions.approveRejectKudosRequest,
        handleApproveRejectKudosRequest,
    );
}



function* rootKudosSaga() {
    yield all([
        handleAddKudosCategoryRequest(),
        handleAddKudosCategoryWatcher(),

        handleGetKudosCategoryRequest(),
        handleGetKudosCategoryWatcher(),

        handleCreateKudosRequest(),
        handleCreateKudosWatcher(),

        handleGetKudosDataRequest(),
        handleGetKudosDataWatcher(),

        handleAddKudosPointHistoryRequest(),
        handleAddKudosPointHistoryWatcher(),

        handleGetPointStatementRequest(),
        handleGetPointStatementWatcher(),

        handleGetUserKudosOnTypeRequest(),
        handleGetUserKudosOnTypeWatcher(),
        
        handleApproveRejectKudosRequest(),
        handleApproveRejectKudosWatcher(),
    ]);
}

export default rootKudosSaga;
